import { render, staticRenderFns } from "./WonderTopicFollowing.vue?vue&type=template&id=58fc5a2a&scoped=true"
import script from "./WonderTopicFollowing.vue?vue&type=script&lang=js"
export * from "./WonderTopicFollowing.vue?vue&type=script&lang=js"
import style0 from "./WonderTopicFollowing.vue?vue&type=style&index=0&id=58fc5a2a&prod&scoped=true&lang=css"
import style1 from "./WonderTopicFollowing.vue?vue&type=style&index=1&id=58fc5a2a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58fc5a2a",
  null
  
)

export default component.exports